<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-video-chat`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 4h14a1 1 0 01.993.883L20 5v14a1 1 0 01-.883.993L19 20H5a1 1 0 01-.993-.883L4 19V5a1 1 0 01.883-.993L5 4h14H5zm21.994 3.652l.006.114v8.468a1 1 0 01-1.413.91l-.101-.053L22 15V9l3.486-2.091a1 1 0 011.508.743zM16 8H8v8h8V8zm26.774 3.946c2.097.767 3.515 2.897 3.177 5.235l-.07.469c-2.42 15.416-13.244 25.797-28.564 28.289l-.224.031c-2.235.256-4.261-1.1-5.043-3.099l-1.809-4.63-.066-.185a3.5 3.5 0 011.845-4.263l7.229-3.365.205-.088a3.485 3.485 0 013.321.434l2.501 1.828.199-.13a26.84 26.84 0 003.425-2.717l.448-.431.456-.46a23.41 23.41 0 003.157-4.082l-.197.313-1.841-2.648-.124-.191a3.507 3.507 0 01-.208-3.22l3.054-6.948.083-.177a3.486 3.486 0 014.306-1.699l4.74 1.734zM20.66 34.184l-6.524 3.036 1.64 4.195c.156.399.497.588.8.584l.099-.009.444-.075c13.584-2.373 22.885-11.581 24.873-25.307l.007-.105c0-.317-.206-.657-.599-.801l-4.286-1.567-2.749 6.256 1.883 2.707.114.174c.65 1.063.71 2.446.018 3.586l-.364.582a27.712 27.712 0 01-3.86 4.733l-.519.499a31.03 31.03 0 01-4.536 3.516l-.186.111a3.443 3.443 0 01-3.697-.246l-2.558-1.869z"/></svg>
</template>
<script>

export default {
  name: 'IconVideoChat',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
